import { render, staticRenderFns } from "./MovementHistoryModal.vue?vue&type=template&id=838a5f52"
import script from "./MovementHistoryModal.vue?vue&type=script&lang=js"
export * from "./MovementHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports